<template>
  <div class="cashier-page-wrapper">
    <div class="page-content">
      <page-header-wrapper>
      <div class="cashier-container">
        <!-- 左侧导航菜单 -->
      <div class="cashier-sidebar">
          <div
            v-for="menu in menus"
            :key="menu.key"
            :class="['menu-item', { active: activeMenu === menu.key }]"
            @click="activeMenu = menu.key"
          >
            <a-icon :type="menu.icon" />
            <span>{{ menu.title }}</span>
          </div>
        </div>

        <!-- 右侧内容区域 -->
        <div class="cashier-content">
          <!-- 顶部工具栏 -->
          <div class="cashier-toolbar">
            <h2 class="page-title">{{ menus.find(m => m.key === activeMenu)?.title || '收银台' }}</h2>
            <a-button
              type="primary"
              @click="toggleFullscreen"
            :icon="isFullscreen ? 'fullscreen-exit' : 'fullscreen'"
              size="small"
            >
            {{ isFullscreen ? '退出全屏' : '全屏' }}
            </a-button>
          </div>

        <!-- 收银页面 -->
        <div v-show="activeMenu === 'cashier'" class="content-section cashier-section">
          <!-- 商品选择区 -->
          <div class="goods-section">
            <!-- SKU编码输入 -->
            <div class="sku-input-wrapper">
<!--              <div class="action-label">-->
<!--                <a-icon type="scan" />-->
<!--                <span>快速扫码</span>-->
<!--              </div>-->
              <div class="sku-search-bar">
                <a-input
                  v-model="skuCode"
                  placeholder="扫描或输入SKU"
                  size="large"
                  @pressEnter="handleSkuSearch"
                  allow-clear
                  ref="skuInput"
                  auto-focus
                >
                  <a-icon slot="prefix" />
                </a-input>
                <a-button type="primary" size="large" @click="handleSkuSearch">
                  <a-icon type="search" />
                  搜索
                </a-button>
              </div>
            </div>
            <!-- 商品分类 -->
            <div class="category-section">
              <div class="category-tabs">
                <div
                  v-for="category in categories"
                  :key="category.id"
                  :class="['category-tab', { active: activeCategory === category.id }]"
                  @click="handleCategoryClick(category.id)"
                >
                  {{ category.name }}
                </div>
              </div>

            </div>

            <!-- 商品列表 -->
            <div class="goods-list">
              <div class="goods-grid">
                <div
                  v-for="goods in filteredGoodsList"
                  :key="goods.id"
                  class="goods-item"
                >
                  <div class="goods-image">
                    <img :src="goods.picture || goods.image || '/static/default-goods.png'" :alt="goods.goodsName" @error="handleImageError" />
                  </div>
                  <div class="goods-info">
                    <div class="goods-name" :title="goods.goodsName">{{ goods.goodsName || '未知商品' }}</div>
<!--                    <div class="goods-spec" v-if="goods.skuName">{{ goods.skuName }}</div>-->
                    <div class="goods-barcode" v-if="goods.barcode">条码: {{ goods.barcode }}</div>
                    <div class="goods-price">¥{{ Number(goods.price || 0).toFixed(2) }}</div>
                    <div class="goods-stock">库存: {{ goods.stock || 0 }}</div>
                    <a-button
                      type="primary"
                      size="small"
                      @click.stop="handleAddToCart(goods)"
                      :disabled="(goods.stock || 0) <= 0"
                      class="add-cart-btn"
                    >
                      <a-icon type="shopping-cart" />
                    </a-button>
                  </div>
                </div>
                <div v-if="filteredGoodsList.length === 0" class="empty-goods">
                  <a-icon type="inbox" style="font-size: 48px; color: #ccc" />
                  <p>暂无商品</p>
                </div>
              </div>
              <!-- 分页组件 -->
              <div class="goods-pagination">
                <a-pagination
                  :current="goodsPagination.current"
                  :pageSize="goodsPagination.pageSize"
                  :total="goodsPagination.total"
                  :showSizeChanger="true"
                  :showQuickJumper="true"
                  :showTotal="total => `共 ${total} 条`"
                  @change="handleGoodsPageChange"
                  @showSizeChange="handleGoodsPageChange"
                />
              </div>
            </div>
          </div>

          <!-- 右侧容器：会员搜索 + 购物车 -->
          <div class="cashier-right-panel">
            <!-- 会员选择区 -->
            <div class="member-section-cart-top">
              <!-- 搜索会员按钮 -->
              <div class="member-search-btn">
                <a-input-search
                  v-model="cashierMemberKeyword"
                  placeholder="输入手机号或姓名搜索"
                  size="large"
                  @search="handleCashierSearchMember"
                  allow-clear
                  enter-button
                >
                  <a-icon slot="prefix" type="search" />
                </a-input-search>
              </div>

              <!-- 当前客户信息 -->
              <div v-if="selectedMemberInfo" class="current-member">
                <div class="member-label">
                  <span>当前会员</span>
                  <a-button type="link" size="small" @click="handleClearMember" style="padding: 0">
                    <a-icon type="close-circle" />
                    取消选择
                  </a-button>
                </div>
                <div class="member-info">
                  <div class="member-name">{{ selectedMemberInfo.nickName || selectedMemberInfo.realName || selectedMemberInfo.mobile }}</div>
                  <div class="member-level">
                    <a-tag :color="memberLevelColor">
                      {{ selectedMemberInfo.levelName || '普通会员' }}
                    </a-tag>
                  </div>
                  <div class="member-balance">手机: {{ selectedMemberInfo.mobile }}</div>
                </div>
              </div>
            </div>

            <!-- 购物车 -->
          <div class="cart-section">


            <div class="cart-header">
              <span>购物车</span>
              <span>共 {{ cart.length }} 件</span>
            </div>
            <div class="cart-list">
              <div v-if="cart.length === 0" class="empty-cart">
                <a-icon type="shopping-cart" style="font-size: 48px; color: #ccc" />
                <p>购物车是空的</p>
              </div>
              <div
                v-for="(item, index) in cart"
                :key="'cart_' + index"
                class="cart-item"
              >
                <div class="item-info">
                  <div class="item-name">{{ item.goodsName || item.name }}</div>
                  <div class="item-spec" v-if="item.skuName">{{ item.skuName }}</div>
                  <div class="item-price">¥{{ (Number(item.price || 0) * item.quantity).toFixed(2) }}</div>
                </div>
                <div class="item-controls">
                  <a-button-group>
                    <a-button size="small" @click="handleDecreaseQuantity(index)" :disabled="item.quantity <= 1">-</a-button>
                    <a-input-number
                      :value="item.quantity"
                      :min="1"
                      :max="item.stock"
                      size="small"
                      :style="{ width: '60px' }"
                      @change="(value) => handleQuantityChange(index, value)"
                    />
                    <a-button size="small" @click="handleIncreaseQuantity(index)">+</a-button>
                  </a-button-group>
                  <a-button type="danger" size="small" icon="delete" @click="handleRemoveFromCart(index)" />
                </div>
              </div>
            </div>
            <div class="cart-summary">
              <div class="summary-item">
                <span>商品总数：</span>
                <span>{{ totalQuantity }}</span>
              </div>
              <div class="summary-item">
                <span>商品金额：</span>
                <span>¥{{ totalAmount.toFixed(2) }}</span>
              </div>
              <div v-if="selectedMemberInfo && memberDiscount > 0" class="summary-item">
                <span>会员折扣：</span>
                <span>-¥{{ memberDiscount.toFixed(2) }}</span>
              </div>
              <div v-if="useScore && scoreDeductionAmount > 0" class="summary-item">
                <span>积分抵扣：</span>
                <span>-¥{{ scoreDeductionAmount.toFixed(2) }}</span>
              </div>
              <div v-if="couponDiscount > 0" class="summary-item">
                <span>优惠券：</span>
                <span>-¥{{ couponDiscount.toFixed(2) }}</span>
              </div>
              <div class="summary-item total">
                <span>应付金额：</span>
                <span class="total-price">¥{{ payableAmount.toFixed(2) }}</span>
              </div>
            </div>

            <!-- 收银操作按钮 -->
            <div class="checkout-actions">
              <a-button type="primary" size="large" @click="openCheckoutModal" :loading="checkoutLoading" block>
                <a-icon type="shopping-cart" />
                收银结算
              </a-button>
              <a-button size="large" @click="handleClearCart" block>
                <a-icon type="delete" />
                清空购物车
              </a-button>
            </div>
          </div>
          </div>
        </div>

        <!-- 会员管理页面 -->
        <div v-show="activeMenu === 'member'" class="content-section">
          <member-manage ref="memberManage" />
        </div>

        <!-- 充值记录页面 -->
        <div v-show="activeMenu === 'recharge'" class="content-section">
          <recharge-record ref="rechargeRecord" />
        </div>

        <!-- 订单页面 -->
        <div v-show="activeMenu === 'order'" class="content-section">
          <order-manage ref="orderManage" />
        </div>

        <!-- 订单详情组件 -->
        <order-detail ref="orderDetail" />

        <!-- 交班页面 -->
        <div v-show="activeMenu === 'shift'" class="content-section">
          <shift-record ref="shiftRecord" />
        </div>
      </div>
    </div>

    </page-header-wrapper>
    </div>

    <!-- 收银结算弹窗 -->
    <a-modal
      width="900px"
      :visible="checkoutModalVisible"
      :title="checkoutLoading && checkoutPayType === 2 ? '微信支付中...' : '收银结算'"
      @cancel="closeCheckoutModal"
      :maskClosable="false"
      :closable="!(checkoutLoading && checkoutPayType === 2)"
      :footer="null"
      getContainer="body"
      :wrapClassName="'checkout-modal-wrapper'"
    >
      <div class="checkout-modal-container">
        <!-- 左侧：订单信息 -->
        <div class="checkout-modal-left">
          <a-card
            :bordered="false"
            title="订单信息"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '40px', 'border-bottom': '1px solid #DDD' }"
            :bodyStyle="{ 'background-color': '#fbfbfb' }"
            style="margin-bottom: 16px"
          >
            <table class="info-table">
              <tr>
                <td class="label">商品总数：</td>
                <td class="value">{{ totalQuantity }}</td>
              </tr>
              <tr>
                <td class="label">商品金额：</td>
                <td class="value">¥{{ totalAmount.toFixed(2) }}</td>
              </tr>
              <tr v-if="selectedMemberInfo && memberDiscount > 0">
                <td class="label">会员折扣：</td>
                <td class="value discount">-¥{{ memberDiscount.toFixed(2) }}</td>
              </tr>
              <tr v-if="useScore && scoreDeductionAmount > 0">
                <td class="label">积分抵扣：</td>
                <td class="value discount">-¥{{ scoreDeductionAmount.toFixed(2) }}</td>
              </tr>
              <tr v-if="couponDiscount > 0">
                <td class="label">优惠券：</td>
                <td class="value discount">-¥{{ couponDiscount.toFixed(2) }}</td>
              </tr>
              <tr class="total-row">
                <td class="label">应付金额：</td>
                <td class="value total">¥{{ payableAmount.toFixed(2) }}</td>
              </tr>
            </table>
          </a-card>

          <!-- 商品列表 -->
          <a-card
            :bordered="false"
            title="商品明细"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '40px', 'border-bottom': '1px solid #DDD' }"
            :bodyStyle="{ 'background-color': '#fbfbfb', 'padding': '12px' }"
          >
            <div class="goods-list" v-for="(item, index) in cart" :key="index">
              <div class="goods-item">
                <img v-if="item.image" :src="item.image" class="goods-image" alt="商品图片" />
                <div class="goods-info">
                  <div class="goods-name">{{ item.goodsName }}</div>
                  <div class="goods-spec" v-if="item.skuName">{{ item.skuName }}</div>
                  <div class="goods-price">
                    <span class="price">¥{{ Number(item.price || 0).toFixed(2) }}</span>
                    <span class="count">x{{ item.quantity }}</span>
                  </div>
                </div>
              </div>
            </div>
          </a-card>
        </div>

        <!-- 右侧：会员信息和支付方式 -->
        <div class="checkout-modal-right">
          <!-- 会员信息 -->
          <a-card
            :bordered="false"
            title="会员信息"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '40px', 'border-bottom': '1px solid #DDD' }"
            :bodyStyle="{ 'background-color': '#fbfbfb' }"
            style="margin-bottom: 16px"
          >
            <div v-if="selectedMemberInfo">
              <table class="info-table">
                <tr>
                  <td class="label">会员姓名：</td>
                  <td class="value">{{ selectedMemberInfo.nickName || selectedMemberInfo.realName }}</td>
                </tr>
                <tr>
                  <td class="label">手机号：</td>
                  <td class="value">{{ selectedMemberInfo.mobile }}</td>
                </tr>
                <tr>
                  <td class="label">会员等级：</td>
                  <td class="value">
                    <a-tag :color="memberLevelColor">
                      {{ selectedMemberInfo.levelName || '普通会员' }}
                    </a-tag>
                  </td>
                </tr>
                <tr>
                  <td class="label">会员折扣：</td>
                  <td class="value discount">{{ memberDiscountText }}</td>
                </tr>
                <tr>
                  <td class="label">账户余额：</td>
                  <td class="value" style="color: #52c41a; font-weight: 600;">
                    ¥{{ memberBalance.toFixed(2) }}
                  </td>
                </tr>
                <tr v-if="selectedMemberInfo">
                  <td class="label">可用积分：</td>
                  <td class="value" style="color: #faad14; font-weight: 600;">
                    {{ memberScore }} 分
                  </td>
                </tr>
              </table>
            </div>
            <div v-else style="text-align: center; color: #999; padding: 20px;">
              <a-icon type="user" style="font-size: 32px;" />
              <p style="margin-top: 10px;">普通客户</p>
            </div>
          </a-card>

          <!-- 支付方式 -->
          <a-card
            :bordered="false"
            title="支付方式"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '40px', 'border-bottom': '1px solid #DDD' }"
            :bodyStyle="{ 'background-color': '#fbfbfb' }"
            style="margin-bottom: 16px"
          >
            <a-radio-group v-model="checkoutPayType" style="width: 100%" name="checkoutPayType">
              <div class="payment-grid">
                <div
                  v-for="(item, index) in payTypes"
                  :key="index"
                  :class="['payment-option', { 'selected': checkoutPayType === item.value, 'disabled': item.requireMember && !selectedMemberInfo }]"
                  @click="!item.requireMember || selectedMemberInfo ? checkoutPayType = item.value : null"
                >
                  <a-radio :value="item.value" class="payment-radio" :disabled="item.requireMember && !selectedMemberInfo">
                    <a-icon :type="item.icon" :style="{ color: item.color, fontSize: '18px', marginRight: '6px' }" />
                    <span class="payment-label">{{ item.label }}</span>
                  </a-radio>
                </div>
              </div>
            </a-radio-group>
            <div v-if="checkoutPayType === 6 && selectedMemberInfo" style="margin-top: 12px; padding: 8px 12px; background: #f0f9ff; border-radius: 4px; font-size: 13px; color: #1890ff;">
              <a-icon type="info-circle" style="margin-right: 4px;" />
              可用余额：¥{{ memberBalance.toFixed(2) }}
              <span v-if="memberBalance < payableAmount" style="margin-left: 12px; color: #ff4d4f;">
                余额不足，请选择其他支付方式
              </span>
            </div>
            <!-- 混合支付：余额 + 其他支付方式（仅纯余额支付时不展示，避免重复） -->
            <div v-if="selectedMemberInfo && checkoutPayType !== 6" style="margin-top: 12px; padding: 10px 12px; background: #f6ffed; border: 1px solid #b7eb8f; border-radius: 4px;">
              <div class="balance-mix-header">
                <a-checkbox v-model="useBalance" @change="handleUseBalanceChange">
                  使用余额抵扣（先扣余额，剩余用「{{ payTypeName }}」支付）
                </a-checkbox>
                <span class="balance-available">可用余额：¥{{ memberBalance.toFixed(2) }}</span>
              </div>
              <div v-if="useBalance" class="balance-mix-body">
                <div class="balance-mix-row">
                  <span class="balance-mix-label">余额支付：</span>
                  <a-input-number
                    v-model="balancePayAmount"
                    :min="0"
                    :max="maxBalancePayAmount"
                    :precision="2"
                    :step="1"
                    size="small"
                    style="width: 160px"
                    @change="onBalancePayAmountChange"
                  />
                  <a-button type="link" size="small" @click="setBalancePayMax">最大</a-button>
                </div>
                <div class="balance-mix-row balance-mix-tip">
                  <span>余额抵扣：<b style="color:#52c41a">¥{{ Math.min(balancePayAmount || 0, maxBalancePayAmount).toFixed(2) }}</b></span>
                  <span style="margin-left:16px;">其他支付：<b style="color:#1890ff">¥{{ otherPayAmount.toFixed(2) }}</b>（{{ payTypeName }}）</span>
                </div>
                <div v-if="memberBalance < payableAmount" class="balance-mix-warn">
                  <a-icon type="warning" /> 余额不足以支付全额，剩余 ¥{{ otherPayAmount.toFixed(2) }} 将通过「{{ payTypeName }}」支付
                </div>
              </div>
            </div>
          </a-card>

          <!-- 微信付款码输入 -->
          <a-card
            v-if="checkoutPayType === 2"
            :bordered="false"
            title="微信付款码"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '40px', 'border-bottom': '1px solid #DDD' }"
            :bodyStyle="{ 'background-color': '#fbfbfb' }"
            style="margin-bottom: 16px"
          >
            <div class="auth-code-section">
              <div style="margin-bottom: 8px; color: #666; font-size: 13px;">
                <a-icon type="scan" style="margin-right: 4px;" />
                请顾客打开微信「收付款」展示付款码，输入下方18位数字
              </div>
              <a-input
                ref="authCodeInput"
                v-model="authCode"
                placeholder="扫描或输入微信付款码（18位数字，10-19开头）"
                size="large"
                allow-clear
                style="width: 100%"
              >
                <a-icon slot="prefix" type="wechat" style="color: #09bb07;" />
              </a-input>
            </div>
          </a-card>

          <!-- 积分抵扣 -->
          <a-card
            v-if="selectedMemberInfo && memberScore > 0"
            :bordered="false"
            title="积分抵扣"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '40px', 'border-bottom': '1px solid #DDD' }"
            :bodyStyle="{ 'background-color': '#fbfbfb' }"
            style="margin-bottom: 16px"
          >
            <div class="score-deduction-section">
              <div class="score-toggle-row">
                <a-checkbox v-model="useScore">
                  使用积分抵扣
                </a-checkbox>
                <div v-if="useScore" class="score-info">
                  <span class="score-text">可用积分：<span class="score-value">{{ memberScore }}</span> 分</span>
                  <span class="score-rate">({{ scoreExchangeRate }}积分 = 1元)</span>
                </div>
              </div>
              <div v-if="useScore" class="score-detail-row">
                <div class="score-detail-item">
                  <span class="detail-label">可抵扣金额：</span>
                  <span class="detail-value">¥{{ maxScoreDeductionAmount.toFixed(2) }}</span>
                </div>
                <div class="score-detail-item">
                  <span class="detail-label">本次抵扣金额：</span>
                  <a-input-number
                    v-model="scoreDeductionAmount"
                    :min="0"
                    :max="maxScoreDeductionAmount"
                    :precision="2"
                    :step="0.01"
                    size="small"
                    style="width: 120px"
                    @change="handleScoreAmountChange"
                  />
                </div>
                <div class="score-detail-item">
                  <span class="detail-label">使用积分：</span>
                  <span class="detail-value highlight">{{ (scoreDeductionAmount * scoreExchangeRate).toFixed(0) }} 积分</span>
                </div>
              </div>
              <div v-if="useScore" class="score-remaining-row">
                <span>抵扣后剩余积分：</span>
                <span class="remaining-value">{{ (memberScore - scoreDeductionAmount * scoreExchangeRate).toFixed(0) }} 分</span>
              </div>
            </div>
          </a-card>

          <!-- 优惠券 -->
          <a-card
            v-if="selectedMemberInfo"
            :bordered="false"
            title="优惠券"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '40px', 'border-bottom': '1px solid #DDD' }"
            :bodyStyle="{ 'background-color': '#fbfbfb', 'padding': '12px' }"
            style="margin-bottom: 16px"
          >
            <!-- 已选中优惠券 -->
            <div v-if="selectedCouponInfo" class="selected-coupon-banner">
              <a-tag color="#f5222d" style="font-size: 14px; padding: 4px 12px; margin-bottom: 8px;">
                <a-icon type="gift" />
                {{ selectedCouponInfo.couponName }}
              </a-tag>
              <span class="coupon-value">-¥{{ selectedCouponInfo.money ? Number(selectedCouponInfo.money).toFixed(2) : '0.00' }}</span>
              <a-button type="link" size="small" @click="handleSelectCoupon(null)" style="margin-left: 8px;">
                <a-icon type="close-circle" />
                不使用
              </a-button>
            </div>
            <!-- 有可用优惠券：展示列表 -->
            <div v-else-if="availableCoupons.length > 0" class="coupon-list">
              <div class="coupon-select-hint">
                共 {{ availableCoupons.length }} 张可用优惠券，请选择一张使用
              </div>
              <div
                v-for="coupon in availableCoupons"
                :key="coupon.id"
                :class="['coupon-item', { 'coupon-disabled': !isCouponAvailable(coupon) }]"
                @click="isCouponAvailable(coupon) && handleSelectCoupon(coupon)"
              >
                <div class="coupon-left">
                  <div class="coupon-amount">
                    <span class="coupon-symbol">¥</span>
                    <span class="coupon-money">{{ Number(coupon.money || 0).toFixed(2) }}</span>
                  </div>
                  <div v-if="Number(coupon.atLeast || 0) > 0" class="coupon-condition">
                    满{{ Number(coupon.atLeast).toFixed(2) }}可用
                  </div>
                  <div v-else class="coupon-condition coupon-no-limit">无门槛</div>
                </div>
                <div class="coupon-right">
                  <div class="coupon-name">{{ coupon.couponName || '优惠券' }}</div>
                  <div class="coupon-expire">{{ coupon.endTime || '' }} 到期</div>
                  <div v-if="!isCouponAvailable(coupon)" class="coupon-unavailable-msg">
                    未满足使用条件
                  </div>
                </div>
                <div class="coupon-check" v-if="selectedCouponId === coupon.id">
                  <a-icon type="check-circle" style="color: #52c41a; font-size: 20px;" />
                </div>
              </div>
            </div>
            <!-- 无可用优惠券 -->
            <div v-else class="coupon-empty">
              <a-icon type="gift" style="font-size: 20px; color: #bbb; margin-right: 8px;" />
              <span style="color: #999;">暂无可用优惠券</span>
            </div>
          </a-card>

          <!-- 议价调整 -->
          <a-card
            :bordered="false"
            title="议价调整"
            :headStyle="{ 'background-color': '#f3f3f3', 'height': '40px', 'border-bottom': '1px solid #DDD' }"
            :bodyStyle="{ 'background-color': '#fbfbfb' }"
            style="margin-bottom: 16px"
          >
            <div style="display: flex; align-items: center;">
              <a-input-number
                v-model="bargainDiscount"
                :precision="2"
                placeholder="正数加价，负数减价"
                style="width: 200px"
                size="large"
              />
            </div>
            <div style="margin-top: 6px; font-size: 12px; color: #999;">
              输入正数增加总金额，输入负数减少总金额，不影响商品单价和订单金额
            </div>
          </a-card>

          <!-- 备注 -->
          <div style="margin-bottom: 16px">
            <a-textarea
              v-model="checkoutRemark"
              placeholder="请输入备注信息"
              :rows="3"
              :maxLength="200"
            />
          </div>

          <!-- 底部操作按钮 -->
          <div class="bottom-actions">
            <a-button type="primary" size="large" :loading="checkoutLoading" @click="handleCheckout" block>
              <a-icon type="check-circle" />
              确认支付 ¥{{ payableAmount.toFixed(2) }}
            </a-button>
            <a-button size="large" @click="closeCheckoutModal" block style="margin-top: 12px">
              取消
            </a-button>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 小票打印弹窗 -->
    <receipt-print-modal
      :visible="receiptVisible"
      :receiptData="receiptData"
      @update:visible="val => receiptVisible = val"
    />
  </div>
</template>

<script>
import { listGoodsCategory, pageSku, searchGoodsBySku } from '@/api/retail/goods'
import { listMember, getMemberDetail } from '@/api/retail/member'
import { createCashierOrder, getCashierOrderDetail } from '@/api/retail/order'
import { getSell } from '@/api/order/sell'
import { calculateMemberDiscount, getUserScore } from '@/api/retail/plus'
import { listCashierAvailableCoupons } from '@/api/coupon/couponReceive'
import OrderDetail from './modules/OrderDetail'
import OrderManage from './OrderManage'
import MemberManage from './modules/MemberManage'
import RechargeRecord from './modules/RechargeRecord'
import ShiftRecord from './modules/ShiftRecord'
import ReceiptPrintModal from './modules/ReceiptPrintModal'

export default {
  name: 'CashierIndex',
  components: {
    OrderDetail,
    OrderManage,
    MemberManage,
    RechargeRecord,
    ShiftRecord,
    ReceiptPrintModal
  },
  data() {
    return {
      activeMenu: 'cashier',
      menus: [
        { key: 'cashier', title: '收银', icon: 'shopping-cart' },
        { key: 'member', title: '会员', icon: 'user' },
        { key: 'recharge', title: '充值记录', icon: 'wallet' },
        { key: 'order', title: '订单', icon: 'file-text' },
        { key: 'shift', title: '交班', icon: 'swap' }
      ],
      selectedMember: undefined,
      memberList: [],
      searchKeyword: '',
      skuCode: '',
      activeCategory: -1,
      categories: [],
      goodsList: [],
      cart: [],
      cashierMemberKeyword: '',
      goodsPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      checkoutLoading: false,
      memberLoading: false,
      rechargeLoading: false,
      // 收银结算弹窗相关
      checkoutModalVisible: false,
      checkoutPayType: 1,
      checkoutRemark: '',
      authCode: '',
      // 混合支付：是否使用余额抵扣
      useBalance: false,
      // 混合支付：余额支付金额（先扣余额，剩余用其他支付方式）
      balancePayAmount: 0,
      payTypes: [
        { label: '微信支付', value: 2, icon: 'wechat', color: '#09bb07' },
        { label: '支付宝', value: 1, icon: 'alipay', color: '#1677ff' },
        // { label: '银行卡', value: 4, icon: 'credit-card', color: '#ff9800' },
        { label: '现金', value: 10, icon: 'wallet', color: '#52c41a' },
        // { label: '扫码支付', value: 5, icon: 'scan', color: '#722ed1' },
        { label: '余额支付', value: 6, icon: 'account-book', color: '#faad14', requireMember: true }
      ],
      // 全屏状态
      isFullscreen: false,
      // 会员折扣计算信息
      calculatedDiscountInfo: null,
      discountCalculationLoading: false,
      // 积分抵扣相关
      userScore: 0, // 用户可用积分
      useScore: false, // 是否使用积分
      scoreDeductionAmount: 0, // 积分抵扣金额
      scoreExchangeRate: 100, // 积分兑换比例: 100积分 = 1元
      bargainDiscount: 0, // 议价金额
      // 优惠券相关
      availableCoupons: [], // 用户可用优惠券列表
      selectedCouponId: null, // 选中的优惠券ID
      selectedCouponInfo: null, // 选中的优惠券详细信息
      // 小票打印相关
      receiptVisible: false,
      receiptData: null
    }
  },
  computed: {
    // 是否处于全屏模式
    isFullscreenMode() {
      return this.isFullscreen
    },
    filteredGoodsList() {
      let list = this.goodsList
      // 只保留关键词搜索过滤,分类筛选已在接口层面完成
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase()
        list = list.filter(item =>
          (item.goodsName || '').toLowerCase().includes(keyword) ||
          (item.skuName || '').toLowerCase().includes(keyword) ||
          (item.skuCode || '').toLowerCase().includes(keyword) ||
          (item.barcode || '').toLowerCase().includes(keyword)
        )
      }
      return list
    },
    totalQuantity() {
      return this.cart.reduce((sum, item) => sum + item.quantity, 0)
    },
    totalAmount() {
      return this.cart.reduce((sum, item) => sum + (item.price * item.quantity), 0)
    },
    selectedMemberInfo() {
      const member = this.memberList.find(m => m.id === this.selectedMember)
      if (member) {
        // 直接使用后端返回的 levelName
        const levelName = member.levelName || '普通会员'
        const discountRate = this.getMemberDiscountRate(levelName)
        return {
          ...member,
          levelName,
          discountRate
        }
      }
      return null
    },
    memberDiscount() {
      // 如果没有选中会员或没有折扣信息,返回0
      if (!this.selectedMemberInfo || !this.memberDiscountInfo) return 0
      // 后端返回的是字符串,需要转换为数字
      const discount = this.memberDiscountInfo.totalDiscount
      return discount ? parseFloat(discount) : 0
    },
    memberDiscountInfo() {
      // 会员折扣信息
      return this.calculatedDiscountInfo
    },
    // 会员积分余额
    memberScore() {
      return this.userScore || 0
    },
    // 最大可抵扣积分金额
    maxScoreDeductionAmount() {
      const amountAfterDiscount = this.totalAmount - this.memberDiscount
      // 计算最大可抵扣金额(取积分能抵扣的最大值和折扣后金额的较小值)
      const maxByScore = (this.memberScore / this.scoreExchangeRate).toFixed(2)
      return Math.min(parseFloat(maxByScore), amountAfterDiscount)
    },
    // 优惠券抵扣金额
    couponDiscount() {
      if (!this.selectedCouponInfo) return 0
      return Number(this.selectedCouponInfo.money || 0)
    },
    payableAmount() {
      // 应付金额 = 商品金额 - 会员折扣 - 积分抵扣 - 优惠券抵扣 + 议价调整(正加负减)
      let amount = this.totalAmount - this.memberDiscount - this.scoreDeductionAmount - this.couponDiscount
      amount = amount + (this.bargainDiscount || 0)
      // 确保应付金额不小于0
      return Math.max(0, amount)
    },
    // 会员余额
    memberBalance() {
      if (!this.selectedMemberInfo) return 0
      return Number(this.selectedMemberInfo.rechargeMoney || 0)
    },
    // 混合支付时余额可抵扣的最大金额（不超过应付金额，且不超过账户余额）
    maxBalancePayAmount() {
      if (!this.selectedMemberInfo) return 0
      return Math.min(this.memberBalance, this.payableAmount)
    },
    // 混合支付开启后，扣除余额仍需用其他支付方式支付的金额
    otherPayAmount() {
      if (!this.useBalance) return this.payableAmount
      const balance = Math.min(this.balancePayAmount || 0, this.maxBalancePayAmount)
      return Math.max(0, this.payableAmount - balance)
    },
    // 当前选中的其他支付方式名称（用于混合支付文案展示）
    payTypeName() {
      const type = this.payTypes.find(t => t.value === this.checkoutPayType)
      return type ? type.label : '其他支付'
    },
    memberDiscountText() {
      if (!this.selectedMemberInfo) return '无折扣'
      // 如果有折扣明细,且有实际折扣金额
      if (this.memberDiscountInfo) {
        const totalDiscount = parseFloat(this.memberDiscountInfo.totalDiscount)
        if (totalDiscount > 0) {
          // 计算折扣率: (原价 - 折后价) / 原价
          const originalAmount = parseFloat(this.memberDiscountInfo.originalAmount)
          if (originalAmount > 0) {
            const discountRate = 1 - (totalDiscount / originalAmount)
            return (discountRate * 10).toFixed(1) + '折'
          }
        }
      }
      // 没有实际折扣时,显示无折扣
      return '无折扣'
    },
    memberLevelColor() {
      if (!this.selectedMemberInfo) return 'default'
      // 根据等级名称动态生成颜色
      const colorMap = {
        '普通会员': 'blue',
        'VIP会员': 'gold',
        '白银会员': 'cyan',
        '黄金会员': 'orange',
        '铂金会员': 'purple',
        '钻石会员': 'red'
      }
      const levelName = this.selectedMemberInfo.levelName
      if (colorMap[levelName]) {
        return colorMap[levelName]
      }
      const colors = ['blue', 'green', 'cyan', 'orange', 'red', 'purple', 'pink', 'magenta']
      const hash = levelName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
      return colors[hash % colors.length] || 'default'
    },
  },
  watch: {
    // 选择微信支付时自动聚焦付款码输入框
    checkoutPayType(val) {
      if (val === 2) {
        this.$nextTick(() => {
          if (this.$refs.authCodeInput) {
            this.$refs.authCodeInput.focus()
          }
        })
      }
    },
    // 监听购物车变化,重新计算折扣
    cart: {
      handler() {
        this.calculateMemberDiscountRate()
      },
      deep: true
    },
    // 监听选中会员变化,重新计算折扣和加载积分
    selectedMember(newVal, oldVal) {
      this.calculateMemberDiscountRate()
      if (newVal && newVal !== oldVal) {
        this.loadUserScore()
        this.loadAvailableCoupons()
      } else {
        // 取消选择会员时清空积分和优惠券
        this.userScore = 0
        this.useScore = false
        this.scoreDeductionAmount = 0
        this.availableCoupons = []
        this.selectedCouponId = null
        this.selectedCouponInfo = null
      }
    },
    // 监听购物车变化（增删商品时重新加载可用优惠券）
    'cart.length': function(newLen, oldLen) {
      if (newLen !== oldLen && this.selectedMember) {
        this.loadAvailableCoupons()
      }
    },
    // 监听使用积分开关变化
    useScore(newVal) {
      if (newVal) {
        // 使用积分时,如果当前抵扣金额为0，才设置为最大可抵扣金额
        if (this.scoreDeductionAmount === 0) {
          this.scoreDeductionAmount = this.maxScoreDeductionAmount
        }
      } else {
        // 不使用积分,清零抵扣金额
        this.scoreDeductionAmount = 0
      }
    },
    // 处理积分抵扣金额变化
    handleScoreAmountChange(value) {
      if (value === null || value === undefined) {
        this.scoreDeductionAmount = 0
        return
      }
      // 确保是数字
      const numValue = parseFloat(value)
      if (isNaN(numValue) || numValue < 0) {
        this.scoreDeductionAmount = 0
      } else if (numValue > this.maxScoreDeductionAmount) {
        this.$message.warning(`最大可抵扣金额为 ¥${this.maxScoreDeductionAmount.toFixed(2)}`)
        this.scoreDeductionAmount = this.maxScoreDeductionAmount
      } else {
        // 保留两位小数
        this.scoreDeductionAmount = parseFloat(numValue.toFixed(2))
      }
      // 积分变化后检查优惠券是否还可用
      this.$nextTick(() => this.checkCouponValidity())
    },
    // 会员折扣变化后检查优惠券是否还可用
    memberDiscount() {
      this.$nextTick(() => this.checkCouponValidity())
    },
    // 检查优惠券是否仍然满足使用条件
    checkCouponValidity() {
      if (this.selectedCouponInfo) {
        const atLeast = Number(this.selectedCouponInfo.atLeast || 0)
        if (atLeast > 0) {
          const amountAfterDiscount = this.totalAmount - this.memberDiscount - this.scoreDeductionAmount
          if (amountAfterDiscount < atLeast) {
            this.selectedCouponId = null
            this.selectedCouponInfo = null
            this.$message.info('当前折后金额不满足优惠券使用条件，已自动取消选择')
          }
        }
      }
    }
  },
  mounted() {
    this.loadCategories()
    this.loadGoodsList()
    this.loadMemberList()
    // 自动聚焦SKU输入框
    this.$nextTick(() => {
      if (this.$refs.skuInput) {
        this.$refs.skuInput.focus()
      }
    })
    // 监听全屏变化
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    // 监听 ESC 键退出全屏
    document.addEventListener('keydown', this.handleEscKey)
  },
  beforeDestroy() {
    // 清理：退出全屏模式
    if (this.isFullscreen) {
      this.toggleFullscreen()
    }
    // 移除全屏变化监听
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    // 移除 ESC 键监听
    document.removeEventListener('keydown', this.handleEscKey)
  },
  methods: {
    // 显示全局支付蒙层（直接挂到body，覆盖整个页面）
    showGlobalPayOverlay() {
      if (document.getElementById('global-pay-overlay')) return
      const overlay = document.createElement('div')
      overlay.id = 'global-pay-overlay'
      overlay.innerHTML = `
        <div class="global-pay-content">
          <div class="ant-spin ant-spin-lg ant-spin-spinning">
            <span class="ant-spin-dot ant-spin-dot-spin">
              <i class="ant-spin-dot-item"></i>
              <i class="ant-spin-dot-item"></i>
              <i class="ant-spin-dot-item"></i>
              <i class="ant-spin-dot-item"></i>
            </span>
          </div>
          <p class="global-pay-text">支付中，请勿刷新页面...</p>
          <p class="global-pay-hint">请提醒顾客在微信中完成支付</p>
        </div>
      `
      document.body.appendChild(overlay)
      document.body.style.overflow = 'hidden'
    },
    // 隐藏全局支付蒙层
    hideGlobalPayOverlay() {
      const overlay = document.getElementById('global-pay-overlay')
      if (overlay) {
        document.body.removeChild(overlay)
        document.body.style.overflow = ''
      }
    },
    async loadCategories() {
      try {
        const params = {
          level: 1
        }
        const response = await listGoodsCategory(params)
        if (response.code == 20001 && response.data) {
          this.categories = [
            { id: -1, name: '全部' },
            ...response.data.map(item => ({
              id: item.id,
              name: item.categoryName
            }))
          ]
        }
      } catch (error) {
        this.$message.error('加载商品分类失败')
      }
    },
    async loadGoodsList(categoryId = null, pageNum = 1, pageSize = null) {
      try {
        const params = {
          status: 1, // 只加载上架商品
          pageNum: pageNum,
          pageSize: pageSize || this.goodsPagination.pageSize
        }
        // 如果有分类ID,添加到参数中
        if (categoryId && categoryId !== -1) {
          params.categoryId = categoryId

        }
        const response = await pageSku(params)
        if (response.code == 20001 && response.data) {
          this.goodsList = response.data.records || []
          this.goodsPagination.total = response.data.total || 0
          this.goodsPagination.current = pageNum


        } else {
          this.$message.error('加载商品列表失败:' + (response.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('加载商品列表失败')
      }
    },

    async loadMemberList() {
      try {
        const params = {
          pageNum: 1,
          pageSize: 100
        }
        const response = await listMember(params)
        if (response.code == 20001 && response.data) {
          this.memberList = response.data.records || []
        }
      } catch (error) {
        this.$message.error('加载会员列表失败')
      }
    },
    handleSearch() {
      // 搜索功能 - 根据当前选中的分类重新加载商品列表
      const categoryId = this.activeCategory === -1 ? null : this.activeCategory
      this.loadGoodsList(categoryId, 1)
    },
    // 点击分类标签
    handleCategoryClick(categoryId) {
      this.activeCategory = categoryId
      // 根据分类ID加载商品列表,重置到第一页
      const requestCategoryId = categoryId === -1 ? null : categoryId
      this.loadGoodsList(requestCategoryId, 1)
    },
    // 商品分页变化
    handleGoodsPageChange(page, pageSize) {
      const categoryId = this.activeCategory === -1 ? null : this.activeCategory
      this.goodsPagination.pageSize = pageSize
      this.loadGoodsList(categoryId, page, pageSize)
    },
    async handleSkuSearch() {
      if (!this.skuCode || this.skuCode.trim() === '') {
        this.$message.warning('请输入SKU编码')
        return
      }

      try {
        const keyword = this.skuCode.trim()
        // 使用SKU接口搜索
        const response = await pageSku({
          keyword: keyword,
          status: 1
        })

        if (response.code == 20001 && response.data.records) {
          const records = response.data.records || []
          if (records.length > 0) {
            // 取第一个匹配的SKU
            const sku = records[0]
            if ((sku.stock || 0) <= 0) {
              this.$message.warning('商品库存不足')
              return
            }
            this.handleAddToCart(sku)
            this.skuCode = ''
            this.$nextTick(() => {
              if (this.$refs.skuInput) {
                this.$refs.skuInput.focus()
              }
            })
          } else {
            this.$message.warning('未找到对应商品')
          }
        } else {
          this.$message.warning('未找到对应商品')
        }
      } catch (error) {
        this.$message.error('搜索失败,请重试')
      }
    },
    handleAddToCart(goods) {
      if (goods.stock <= 0) {
        this.$message.warning('商品库存不足')
        return
      }
      const existingIndex = this.cart.findIndex(item => item.goodsId === goods.id)
      if (existingIndex !== -1) {
        if (this.cart[existingIndex].quantity >= goods.stock) {
          this.$message.warning('已达到最大库存数量')
          return
        }
        this.$set(this.cart, existingIndex, { ...this.cart[existingIndex], quantity: this.cart[existingIndex].quantity + 1 })
        this.$message.success('商品数量+1')
      } else {
        const newItem = {
          goodsId: goods.id,
          goodsName: goods.goodsName || goods.name,
          skuName: goods.skuName,
          price: goods.price || goods.salePrice || 0,
          quantity: 1,
          barcode: goods.barcode || goods.skuCode || goods.goodsCode,
          stock: goods.stock || 0,
          image: goods.picture || goods.image,
          categoryId: goods.categoryId, // 添加分类ID,用于计算会员折扣
          plusPrice: goods.plusPrice // PLUS会员价
        }
        this.cart.push(newItem)
        this.$message.success('已添加到购物车')
      }
    },
    handleIncreaseQuantity(index) {
      const item = this.cart[index]
      if (item.quantity < item.stock) {
        this.$set(this.cart, index, { ...item, quantity: item.quantity + 1 })
      } else {
        this.$message.warning('已达到最大库存数量')
      }
    },
    handleDecreaseQuantity(index) {
      const item = this.cart[index]
      if (item.quantity > 1) {
        this.$set(this.cart, index, { ...item, quantity: item.quantity - 1 })
      }
    },
    handleQuantityChange(index, value) {
      const item = this.cart[index]
      if (value === null || value === undefined || value < 1) {
        this.$set(this.cart, index, { ...item, quantity: 1 })
      } else if (value > item.stock) {
        this.$message.warning(`库存不足，最大数量为 ${item.stock}`)
        this.$set(this.cart, index, { ...item, quantity: item.stock })
      } else {
        this.$set(this.cart, index, { ...item, quantity: value })
      }
    },
    handleRemoveFromCart(index) {
      this.cart.splice(index, 1)
    },
    handleClearCart() {
      this.$confirm({
        title: '确认清空',
        content: '确定要清空购物车吗？',
        onOk: () => {
          this.cart = []
          this.$message.success('购物车已清空')
        }
      })
    },
    // 取消选择会员
    handleClearMember() {
      this.$confirm({
        title: '确认取消',
        content: '确定要取消当前会员吗？',
        onOk: () => {
          this.selectedMember = undefined
          this.$message.success('已取消会员选择')
        }
      })
    },
    // 加载用户积分
    async loadUserScore() {
      if (!this.selectedMember) {
        this.userScore = 0
        return
      }
      try {
        const response = await getUserScore(this.selectedMember)
        if (response.code == 20001) {
          this.userScore = response.data || 0
        }
      } catch (error) {
        console.error('加载用户积分失败:', error)
        this.userScore = 0
      }
    },
    // 加载用户可用优惠券
    async loadAvailableCoupons() {
      if (!this.selectedMember) {
        this.availableCoupons = []
        this.selectedCouponId = null
        this.selectedCouponInfo = null
        return
      }
      try {
        // 构造购物车商品列表，传递给后端做商品/分类范围匹配
        const items = this.cart.map(item => ({
          goodsId: item.goodsId,
          categoryId: item.categoryId || null
        }))
        const response = await listCashierAvailableCoupons({
          userId: this.selectedMember,
          shopId: 0, // 平台级，若需要门店级可后续扩展
          items: items
        })
        if (response.code == 20001 && response.data) {
          this.availableCoupons = response.data || []
          // 如果当前选中的优惠券已不可用,清空选择
          if (this.selectedCouponId) {
            const stillAvailable = this.availableCoupons.find(c => c.id === this.selectedCouponId)
            if (!stillAvailable) {
              this.selectedCouponId = null
              this.selectedCouponInfo = null
            }
          }
        } else {
          this.availableCoupons = []
        }
      } catch (error) {
        console.error('加载用户优惠券失败:', error)
        this.availableCoupons = []
      }
    },
    // 选择优惠券
    handleSelectCoupon(coupon) {
      if (!coupon) {
        // 取消选择
        this.selectedCouponId = null
        this.selectedCouponInfo = null
        return
      }
      // 检查满减条件
      const atLeast = Number(coupon.atLeast || 0)
      if (atLeast > 0) {
        const amountAfterDiscount = this.totalAmount - this.memberDiscount - this.scoreDeductionAmount
        if (amountAfterDiscount < atLeast) {
          this.$message.warning(`该优惠券需满 ¥${atLeast.toFixed(2)} 才可使用，当前折后金额 ¥${amountAfterDiscount.toFixed(2)}`)
          return
        }
      }
      // 如果已选中则取消,否则选中
      if (this.selectedCouponId === coupon.id) {
        this.selectedCouponId = null
        this.selectedCouponInfo = null
      } else {
        this.selectedCouponId = coupon.id
        this.selectedCouponInfo = coupon
        this.$message.success(`已选择优惠券「${coupon.couponName}」`)
      }
    },
    // 判断优惠券是否满足使用条件
    isCouponAvailable(coupon) {
      if (!coupon) return false
      const atLeast = Number(coupon.atLeast || 0)
      if (atLeast > 0) {
        const amountAfterDiscount = this.totalAmount - this.memberDiscount - this.scoreDeductionAmount
        return amountAfterDiscount >= atLeast
      }
      return true
    },
    // 打开收银结算弹窗
    openCheckoutModal() {
      if (this.cart.length === 0) {
        this.$message.warning('购物车是空的')
        return
      }
      // 打开弹窗时加载会员积分和优惠券
      if (this.selectedMember) {
        this.loadUserScore()
        this.loadAvailableCoupons()
      }
      // 重置积分抵扣状态
      this.useScore = false
      this.scoreDeductionAmount = 0
      this.checkoutPayType = 1
      this.checkoutRemark = ''
      this.authCode = ''
      this.bargainDiscount = 0
      this.selectedCouponId = null
      this.selectedCouponInfo = null
      this.checkoutModalVisible = true
    },
    // 关闭收银结算弹窗
    closeCheckoutModal() {
      this.checkoutModalVisible = false
      this.checkoutPayType = 1
      this.checkoutRemark = ''
      this.authCode = ''
      this.bargainDiscount = 0
      this.useScore = false
      this.scoreDeductionAmount = 0
      this.selectedCouponId = null
      this.selectedCouponInfo = null
      this.useBalance = false
      this.balancePayAmount = 0
    },
    // 切换是否使用余额抵扣
    handleUseBalanceChange() {
      if (this.useBalance) {
        // 默认抵扣到可用上限（不超过应付金额与账户余额）
        this.balancePayAmount = Number(this.maxBalancePayAmount.toFixed(2))
      } else {
        this.balancePayAmount = 0
      }
    },
    // 点击「最大」一键填满余额抵扣
    setBalancePayMax() {
      this.balancePayAmount = Number(this.maxBalancePayAmount.toFixed(2))
    },
    // 余额支付金额变化时，限制在可用上限内
    onBalancePayAmountChange(val) {
      if (val == null) {
        this.balancePayAmount = 0
        return
      }
      if (val > this.maxBalancePayAmount) {
        this.balancePayAmount = Number(this.maxBalancePayAmount.toFixed(2))
        this.$message.info('余额支付金额不能超过可用余额或应付金额')
      }
    },
    async handleCheckout() {
      if (this.cart.length === 0) {
        this.$message.warning('购物车是空的')
        return
      }

      // 验证使用积分时必须有会员
      if (this.useScore && !this.selectedMember) {
        this.$message.warning('使用积分需要选择会员')
        return
      }

      // 验证微信付款码
      if (this.checkoutPayType === 2) {
        if (!this.authCode || this.authCode.trim() === '') {
          this.$message.warning('微信支付需要输入付款码')
          return
        }
        if (!/^1[0-9]{17}$/.test(this.authCode.trim())) {
          this.$message.warning('付款码格式不正确，应为18位数字（10-19开头）')
          return
        }
      }

      // 纯余额支付校验
      if (this.checkoutPayType === 6) {
        if (!this.selectedMember) {
          this.$message.warning('余额支付需要选择会员')
          return
        }
        if (this.memberBalance < this.payableAmount) {
          this.$message.warning('余额不足，请选择其他支付方式')
          return
        }
      }

      // 混合支付校验：开启了余额抵扣则必须选会员，且余额金额需在可用范围内
      if (this.useBalance) {
        if (!this.selectedMember) {
          this.$message.warning('使用余额抵扣需要选择会员')
          return
        }
        const realBalance = Math.min(this.balancePayAmount || 0, this.maxBalancePayAmount)
        if (realBalance <= 0) {
          this.$message.warning('余额抵扣金额必须大于0')
          return
        }
        if (realBalance > this.memberBalance) {
          this.$message.warning('余额抵扣金额超过账户可用余额')
          return
        }
      }

      // 微信支付显示全局蒙层
      const isWechatPay = this.checkoutPayType === 2
      if (isWechatPay) this.showGlobalPayOverlay()

      this.checkoutLoading = true
      try {
        const orderData = {
          memberId: this.selectedMember,
          goodsList: this.cart.map(item => ({
            goodsId: item.goodsId,
            quantity: item.quantity,
            price: item.price
          })),
          totalAmount: this.totalAmount,
          memberDiscount: this.memberDiscount,
          scoreDeduction: this.scoreDeductionAmount, // 积分抵扣金额
          useScore: !!this.useScore, // 是否使用积分，确保是布尔值
          scoreAmount: this.useScore ? this.scoreDeductionAmount * this.scoreExchangeRate : 0, // 使用的积分数量
          couponId: this.selectedCouponId || null, // 优惠券领取ID
          couponAmount: this.couponDiscount, // 优惠券抵扣金额
          payableAmount: this.payableAmount,
          payMethod: this.checkoutPayType,
          // 余额支付金额：纯余额支付(payType=6)时等于应付金额；混合支付时取实际扣款值；否则为0
          balanceAmount: this.checkoutPayType === 6
            ? this.payableAmount
            : (this.useBalance ? Math.min(this.balancePayAmount || 0, this.maxBalancePayAmount) : 0),
          remark: this.checkoutRemark,
          authCode: this.checkoutPayType === 2 ? this.authCode.trim() : undefined,
          bargainDiscount: this.bargainDiscount || 0
        }
        const response = await createCashierOrder(orderData)
        if (response.code == 20001) {
          this.$message.success('结算成功')
          const orderId = response.data
          // 记录当前会员信息（小票需展示卡号/积分，须在清空前捕获）
          const memberInfo = this.selectedMemberInfo
          let detail = null
          try {
            // 拉取订单详情，获取真实金额/折扣/积分/明细等字段
            const detailResp = await getSell({ id: orderId })
            if (detailResp.code == 20001 && detailResp.data) {
              detail = detailResp.data
            } else {
              // 兜底：用收银订单详情接口（不含商品明细）
              const cashierResp = await getCashierOrderDetail(orderId)
              if (cashierResp.code == 20001 && cashierResp.data) {
                detail = cashierResp.data
              }
            }
          } catch (e) {
            console.error('获取订单详情失败，使用本地数据生成小票', e)
          }
          // 组装小票数据（detail 为空时回退到本地购物车数据）
          this.receiptData = this.buildReceiptData(detail, memberInfo)
          // 清空购物车与会员，并关闭结算弹窗
          this.cart = []
          this.selectedMember = undefined
          this.closeCheckoutModal()
          // 弹出小票打印页面
          this.receiptVisible = true
        } else {
          this.$message.error(response.msg || '结算失败')
        }
      } catch (error) {
        const errMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '结算失败，请重试'
        this.$message.error(errMsg)
      } finally {
        this.checkoutLoading = false
        if (isWechatPay) this.hideGlobalPayOverlay()
      }
    },
    // 组装小票打印数据
    // detail: 订单详情(getSell 返回的完整对象)；为空时回退到本地购物车数据
    // memberInfo: 结算前捕获的会员信息（用于卡号/积分）
    buildReceiptData(detail, memberInfo) {
      const now = new Date()
      const pad = n => String(n).padStart(2, '0')
      const fmtTime = (val) => {
        if (!val) return ''
        const dt = new Date(val)
        if (isNaN(dt.getTime())) return String(val)
        return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())} ` +
          `${pad(dt.getHours())}:${pad(dt.getMinutes())}`
      }
      const userInfo = this.$store.getters.userInfo || {}
      const isDetail = detail && detail.id != null
      const payType = this.payTypes.find(p => p.value === this.checkoutPayType)
      const localPaymentMethod = (payType && payType.label) || '现金'

      // ---------- 头部信息（优先用订单详情真实字段）----------
      const header = {
        store_name: (isDetail && detail.shopName) || userInfo.shopName || userInfo.storeName || '营养坞',
        branch_name: (isDetail && detail.shopName) || userInfo.branchName || userInfo.shopName || '本店',
        warehouse: (isDetail && detail.shopName) || userInfo.warehouse || userInfo.shopName || '本店',
        salesperson: this.$store.getters.nickname || userInfo.nickName || '营业员',
        receipt_no: isDetail
          ? (detail.orderNo != null ? String(detail.orderNo) : String(detail.id))
          : ('NO' + Date.now()),
        transaction_time: isDetail
          ? (fmtTime(detail.payTime) || fmtTime(detail.createTime))
          : fmtTime(now),
        order_status: isDetail ? (detail.orderStatusName || detail.orderStatus || '') : '',
        remark: isDetail
          ? (detail.buyerMessage || detail.adminRemark || '')
          : (this.checkoutRemark || '')
      }

      // ---------- 商品明细（优先用订单明细 orderItemList）----------
      let items = []
      if (isDetail && Array.isArray(detail.orderItemList) && detail.orderItemList.length) {
        items = detail.orderItemList.map((it, idx) => {
          const price = Number(it.price || 0)
          const qty = Number(it.goodsCount || it.quantity || 0)
          const subtotal = price * qty
          const isGift = price === 0
          const baseName = it.goodsName || it.name || '未知商品'
          const name = isGift && !baseName.includes('赠') ? `${baseName} [赠]` : baseName
          return {
            item_index: idx + 1,
            name: name,
            barcode: it.barcode || '',
            spec: it.skuName || '',
            unit_price: price,
            quantity: qty,
            subtotal: subtotal,
            original_price_ref: it.originalPrice != null ? Number(it.originalPrice) : price,
            is_gift: isGift
          }
        })
      } else {
        items = this.cart.map((it, idx) => {
          const price = Number(it.price || 0)
          const qty = Number(it.quantity || 0)
          const subtotal = price * qty
          const isGift = !!it.isGift || price === 0
          const baseName = it.goodsName || it.name || '未知商品'
          const name = isGift && !baseName.includes('赠') ? `${baseName} [赠]` : baseName
          return {
            item_index: idx + 1,
            name: name,
            barcode: it.barcode || '',
            spec: it.skuName || '',
            unit_price: price,
            quantity: qty,
            subtotal: subtotal,
            original_price_ref: it.originalPrice != null ? Number(it.originalPrice) : price,
            is_gift: isGift
          }
        })
      }

      // ---------- 汇总与支付（优先用订单详情真实金额）----------
      const goodsAmount = isDetail && detail.goodsAmount != null ? Number(detail.goodsAmount) : this.totalAmount
      const payAmount = isDetail && detail.payAmount != null ? Number(detail.payAmount) : this.payableAmount
      const plusDiscount = isDetail && detail.plusDiscount != null ? Number(detail.plusDiscount) : this.memberDiscount
      const couponMoney = isDetail && detail.couponMoney != null ? Number(detail.couponMoney) : this.couponDiscount
      const pointDeductionAmount = isDetail && detail.pointDeductionAmount != null ? Number(detail.pointDeductionAmount) : this.scoreDeductionAmount
      const discount = Math.max(0, plusDiscount + couponMoney + pointDeductionAmount)
      const totalQty = isDetail && detail.goodsCount != null ? Number(detail.goodsCount) : this.totalQuantity

      const paymentMethod = isDetail ? (detail.payTypeName || localPaymentMethod) : localPaymentMethod
      const memberName = (isDetail && detail.buyerName) ||
        (memberInfo ? (memberInfo.nickName || memberInfo.realName || '') : '')
      const memberCardNo = memberInfo ? (memberInfo.cardNo || memberInfo.mobile || '') : ''
      // 剩余积分：订单详情接口 order/sell/detail 已直接返回买家交易后剩余积分 detail.userScore；
      // 实时收银未下单时回退到选会员时加载的 this.userScore
      const pointsRemaining = (isDetail && detail.userScore != null && detail.userScore !== '')
        ? Number(detail.userScore)
        : this.userScore

      return {
        header_info: header,
        items_list: items,
        summary_and_payment: {
          total_quantity: totalQty,
          goods_amount: goodsAmount,
          total_amount_payable: payAmount,
          discount_amount: discount,
          original_total_amount: goodsAmount,
          actual_received: payAmount,
          payment_method: paymentMethod,
          paid_amount: payAmount,
          // 优惠明细（参考订单详情字段）
          plus_discount: plusDiscount,
          coupon_amount: couponMoney,
          point_discount_amount: pointDeductionAmount,
          // 会员信息
          member_card_no: memberCardNo,
          member_name: memberName,
          // 积分：后端未在小票返回，此处展示当前可用积分作为剩余积分
          points_earned: '',
          points_remaining: pointsRemaining
        }
      }
    },
    filterMemberOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    formatPrice(price) {
      if (price === null || price === undefined || price === '') {
        return '0.00'
      }
      try {
        return Number(price).toFixed(2)
      } catch (e) {
        return '0.00'
      }
    },
    handleImageError(e) {
      e.target.src = '/static/default-goods.png'
    },
    // 会员折扣率(暂时保留,等待后端提供折扣计算接口)
    // TODO: 后续需要调用后端接口获取真实的会员折扣率
    getMemberDiscountRate(levelName) {
      // 目前使用默认折扣率,等待后端提供接口后替换
      const defaultDiscountRate = 0.95 // 默认95折
      return defaultDiscountRate
    },
    async handleSearchMember() {
      if (!this.memberSearchKeyword || this.memberSearchKeyword.trim() === '') {
        // 如果搜索框为空,重新加载所有会员
        this.loadMemberList()
        return
      }

      try {
        const params = {
          pageNum: 1,
          pageSize: 100,
          keyword: this.memberSearchKeyword.trim()
        }
        const response = await listMember(params)
        if (response.code == 20001 && response.data) {
          const members = response.data.records || []
          if (members.length === 0) {
            this.$message.warning('未找到匹配的会员')
          } else {
            this.memberList = members
            this.$message.success(`找到 ${members.length} 位会员`)
            // 如果只有一位会员,自动选中
            if (members.length === 1) {
              this.selectedMember = members[0].id
            }
          }
        } else {
          this.$message.error('搜索失败')
        }
      } catch (error) {
        this.$message.error('搜索失败,请重试')
      }
    },
    // 收银台搜索会员
    async handleCashierSearchMember() {
      if (!this.cashierMemberKeyword || this.cashierMemberKeyword.trim() === '') {
        // 如果搜索框为空,重新加载所有会员
        this.loadMemberList()
        return
      }

      try {
        const params = {
          pageNum: 1,
          pageSize: 100,
          keyword: this.cashierMemberKeyword.trim()
        }
        const response = await listMember(params)
        if (response.code == 20001 && response.data) {
          const members = response.data.records || []
          if (members.length === 0) {
            this.$message.warning('未找到匹配的会员')
          } else {
            this.memberList = members
            this.$message.success(`找到 ${members.length} 位会员`)
            // 如果只有一位会员,自动选中
            if (members.length === 1) {
              this.selectedMember = members[0].id
            }
          }
        } else {
          this.$message.error('搜索失败')
        }
      } catch (error) {
        this.$message.error('搜索失败,请重试')
      }
    },
    // 会员管理页面搜索会员
    async handleMemberPageSearch() {
      if (!this.memberPageKeyword || this.memberPageKeyword.trim() === '') {
        // 如果搜索框为空,重新加载所有会员
        this.loadMemberList()
        return
      }

      try {
        const params = {
          pageNum: this.memberPagination.current,
          pageSize: this.memberPagination.pageSize,
          keyword: this.memberPageKeyword.trim()
        }
        const response = await listMember(params)
        if (response.code == 20001 && response.data) {
          this.memberList = response.data.records || []
          this.memberPagination.total = response.data.total || 0
        } else {
          this.$message.error('搜索失败')
        }
      } catch (error) {
        this.$message.error('搜索失败,请重试')
      }
    },
    handleMemberTableChange(pagination) {
      this.memberPagination = { ...this.memberPagination, ...pagination }
    },
    handleRechargeDateChange() {
      this.loadRechargeList()
    },
    loadRechargeList() {
      // TODO: 调用接口加载充值记录
    },
    handleRechargeTableChange(pagination) {
      this.rechargePagination = { ...this.rechargePagination, ...pagination }
    },
    // 计算会员折扣
    async calculateMemberDiscountRate() {
      // 如果没有选中会员或购物车为空,清空折扣信息
      if (!this.selectedMember || this.cart.length === 0) {
        this.calculatedDiscountInfo = null
        return
      }

      try {
        this.discountCalculationLoading = true
        const response = await calculateMemberDiscount({
          memberId: this.selectedMember,
          goodsList: this.cart.map(item => ({
            goodsId: item.goodsId,
            quantity: item.quantity,
            price: item.price,
            categoryId: item.categoryId // 需要从商品列表中获取分类ID
          }))
        })

        console.log('会员折扣接口返回:', response)

        if (response.code == 20001 && response.data) {
          this.calculatedDiscountInfo = response.data
          console.log('设置的折扣信息:', this.calculatedDiscountInfo)
          console.log('会员折扣金额:', this.memberDiscount)
        } else {
          // 接口调用失败,使用默认折扣率
          this.calculatedDiscountInfo = {
            totalDiscount: this.totalAmount * this.getMemberDiscountRate(this.selectedMemberInfo?.levelName),
            discountDetails: []
          }
        }
      } catch (error) {
        console.error('计算会员折扣失败:', error)
        // 发生错误时,使用默认折扣率
        this.calculatedDiscountInfo = {
          totalDiscount: this.totalAmount * this.getMemberDiscountRate(this.selectedMemberInfo?.levelName),
          discountDetails: []
        }
      } finally {
        this.discountCalculationLoading = false
      }
    },
    // 处理 ESC 键退出全屏
    handleEscKey(e) {
      if (e.key === 'Escape' && this.isFullscreen) {
        this.toggleFullscreen()
      }
    },
    // 监听全屏变化
    handleFullscreenChange() {
      if (!document.fullscreenElement && this.isFullscreen) {
        // 如果用户通过ESC或其他方式退出了全屏，更新状态
        this.isFullscreen = false

        const pageHeaderWrapper = this.$el.querySelector('.ant-pro-page-header-wrap')
        const cashierContainer = this.$el.querySelector('.cashier-container')

        // 恢复 page-header-wrapper 的头部
        if (pageHeaderWrapper) {
          const pageHeaderWarp = pageHeaderWrapper.querySelector('.ant-pro-page-header-wrap-page-header-warp')
          if (pageHeaderWarp) {
            pageHeaderWarp.style.display = ''
          }
        }

        // 移除全屏样式类
        if (cashierContainer) {
          cashierContainer.classList.remove('cashier-fullscreen-mode')
        }
      }
    },
    // 切换全屏
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen

      const pageHeaderWrapper = this.$el.querySelector('.ant-pro-page-header-wrap')
      const cashierContainer = this.$el.querySelector('.cashier-container')

      if (this.isFullscreen) {
        // 进入全屏模式
        // 隐藏 page-header-wrapper 的头部
        if (pageHeaderWrapper) {
          const pageHeaderWarp = pageHeaderWrapper.querySelector('.ant-pro-page-header-wrap-page-header-warp')
          if (pageHeaderWarp) {
            pageHeaderWarp.style.display = 'none'
          }
        }

        // 添加全屏样式类
        if (cashierContainer) {
          cashierContainer.classList.add('cashier-fullscreen-mode')
        }

        // 请求浏览器全屏（对整个页面全屏）
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen()
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen()
        }

        this.$message.success('已进入全屏模式')
      } else {
        // 退出全屏模式
        // 恢复 page-header-wrapper 的头部
        if (pageHeaderWrapper) {
          const pageHeaderWarp = pageHeaderWrapper.querySelector('.ant-pro-page-header-wrap-page-header-warp')
          if (pageHeaderWarp) {
            pageHeaderWarp.style.display = ''
          }
        }

        // 移除全屏样式类
        if (cashierContainer) {
          cashierContainer.classList.remove('cashier-fullscreen-mode')
        }

        // 退出浏览器全屏
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }

        this.$message.success('已退出全屏模式')
      }
    },
  }
}
</script>

<style scoped lang="less">
.cashier-page-wrapper {
  min-height: 100vh;

  .page-content {
    min-height: 100vh;
  }
}

.cashier-container {
  display: flex;
  height: calc(100vh - 140px);
  background: #f0f2f5;
  overflow: hidden;

  .cashier-sidebar {
    width: 100px;
    background: #001529;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    .menu-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 18px 8px;
      color: #fff;
      cursor: pointer;
      transition: all 0.3s;
      border-left: 3px solid transparent;

      &:hover {
        background: #1890ff;
      }

      &.active {
        background: #1890ff;
        border-left-color: #fff;
      }

      .anticon {
        font-size: 22px;
        margin-bottom: 6px;
      }

      span {
        font-size: 12px;
      }
    }
  }

  .cashier-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .cashier-toolbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      background: #fff;
      border-bottom: 1px solid #e8e8e8;
      flex-shrink: 0;

      .page-title {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }
    }

    .content-section {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 16px;
      overflow: auto;

      &.fullscreen-padding {
        padding: 0;
      }

      .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .header-left {
          display: flex;
          align-items: center;
          gap: 12px;

          h3 {
            margin: 0;
            font-size: 18px;
            font-weight: 600;
            color: #333;
          }
        }
      }
    }

    // 收银页面特殊布局
    .cashier-section {
      display: flex;
      flex-direction: row;
      gap: 16px;
      padding: 0;
      height: 100%;
      overflow: hidden;
    }

    // 会员选择区 - 商品区域上方的布局（已废弃，保留样式兼容）
    .member-section {
      flex: 0 0 320px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      padding: 20px;
      gap: 16px;
      overflow-y: auto;

      .member-select-wrapper {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .action-label {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 15px;
          font-weight: 600;
          color: #333;

          .anticon {
            font-size: 20px;
            color: #1890ff;
          }
        }

        .ant-select {
          .ant-select-selection {
            height: 52px;
          }

          .ant-select-selection__rendered {
            line-height: 50px;
          }
        }
      }

      .member-search-btn {
        .ant-input-search {
          height: 52px;

          .ant-input {
            height: 52px;
            font-size: 15px;
          }

          .ant-input-group-addon {
            .ant-btn {
              height: 52px;
              font-size: 16px;
              font-weight: 600;
            }
          }
        }
      }

      .current-member {
        background: #f0f9ff;
        border: 1px solid #bae7ff;
        border-radius: 8px;
        padding: 14px;

        .member-label {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: #8c8c8c;
          margin-bottom: 10px;

          .ant-btn-link {
            color: #ff4d4f;
            font-size: 12px;
            padding: 0 4px;
            height: auto;

            &:hover {
              color: #ff7875;
            }
          }
        }

        .member-info {
          .member-name {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin-bottom: 8px;
          }

          .member-level {
            margin-bottom: 8px;
          }

          .member-balance {
            font-size: 14px;
            color: #52c41a;
            font-weight: 500;
          }
        }
      }

      .checkout-actions {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: auto;

        .ant-btn {
          height: 52px;
          font-size: 17px;
          font-weight: 600;
        }
      }
    }

    // 右侧容器：会员搜索 + 购物车
    .cashier-right-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
      overflow: hidden;
      min-width: 380px;
      max-width: 40%;
    }

    // 会员选择区 - 购物车上方的小型布局
    .member-section-cart-top {
      flex: 0 0 auto;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      padding: 16px;
      gap: 12px;
      overflow-y: auto;
      flex-shrink: 0;

      .member-search-btn {
        .ant-input-search {
          height: 44px;

          .ant-input {
            height: 44px;
            font-size: 14px;
          }

          .ant-input-group-addon {
            .ant-btn {
              height: 44px;
              font-size: 15px;
              font-weight: 600;
            }
          }
        }
      }

      .current-member {
        background: #f0f9ff;
        border: 1px solid #bae7ff;
        border-radius: 6px;
        padding: 12px;

        .member-label {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: #8c8c8c;
          margin-bottom: 8px;

          .ant-btn-link {
            color: #ff4d4f;
            font-size: 12px;
            padding: 0 4px;
            height: auto;

            &:hover {
              color: #ff7875;
            }
          }
        }

        .member-info {
          .member-name {
            font-size: 14px;
            font-weight: 600;
            color: #333;
            margin-bottom: 6px;
          }

          .member-level {
            margin-bottom: 6px;
          }

          .member-balance {
            font-size: 13px;
            color: #52c41a;
            font-weight: 500;
          }
        }
      }
    }

    // 商品选择区
    .goods-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      min-width: 0;

      .sku-input-wrapper {
        padding: 16px;
        border-bottom: 1px solid #e8e8e8;
        background: #fafafa;
        flex-shrink: 0;

        .action-label {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 15px;
          font-weight: 600;
          color: #333;
          margin-bottom: 10px;

          .anticon {
            font-size: 20px;
            color: #1890ff;
          }
        }

        .sku-search-bar {
          display: flex;
          gap: 10px;

          .ant-input {
            flex: 1;
            height: 52px;
            font-size: 18px;
            font-weight: 500;
            border: 2px solid #1890ff;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);

            &:focus {
              box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
            }

            /deep/ .ant-input-prefix {
              font-size: 20px;
              color: #1890ff;
            }
          }

          .ant-btn {
            height: 52px;
            min-width: 100px;
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
    }

    .category-section {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
    }

    .category-tabs {
      display: flex;
      padding: 10px;
      background: #fafafa;
      border-bottom: 1px solid #e8e8e8;
      overflow-x: auto;

      .category-tab {
        padding: 8px 16px;
        cursor: pointer;
        white-space: nowrap;
        transition: all 0.3s;
        border-bottom: 2px solid transparent;

        &:hover {
          color: #1890ff;
        }

        &.active {
          color: #1890ff;
          border-bottom-color: #1890ff;
          font-weight: 600;
        }
      }
    }

    .search-bar {
      display: flex;
      padding: 14px;
      gap: 10px;

      .ant-input {
        flex: 1;
      }
    }

    .goods-list {
      flex: 1;
      overflow: hidden;
      padding: 14px;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }

    .goods-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      grid-auto-rows: max-content;
      gap: 14px;
      overflow-y: auto;
      flex: 1;
      align-content: start;
    }

    .empty-goods {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 200px;
      color: #8c8c8c;

      p {
        margin-top: 14px;
      }
    }

    .goods-pagination {
      flex-shrink: 0;
      padding: 12px 0 0 0;
      display: flex;
      justify-content: center;
      background: #fff;
      border-top: 1px solid #e8e8e8;
    }

    .goods-item {
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 6px;
      padding: 12px;
      cursor: pointer;
      transition: all 0.3s;
      min-height: 220px;
      display: flex;
      flex-direction: column;

      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
      }

      .goods-image {
        width: 100%;
        height: 110px;
        background: #f5f5f5;
        border-radius: 4px;
        margin-bottom: 10px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .goods-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: visible;
        position: relative;

        .goods-name {
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .goods-spec {
          font-size: 12px;
          color: #666;
          margin-bottom: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .goods-barcode {
          font-size: 11px;
          color: #1890ff;
          margin-bottom: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex-shrink: 0;
          background: #e6f7ff;
          padding: 2px 6px;
          border-radius: 3px;
        }

        .goods-price {
          font-size: 16px;
          color: #f5222d;
          font-weight: 700;
          margin-bottom: 4px;
          flex-shrink: 0;
        }

        .goods-stock {
          font-size: 12px;
          color: #8c8c8c;
          flex-shrink: 0;
        }

        .add-cart-btn {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 32px;
          height: 32px;
          padding: 0;
          border-radius: 50%;

          .anticon {
            font-size: 16px;
            margin: 0;
          }
        }
      }
    }

    .cart-section {
      flex: 1;
      min-height: 0;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      padding: 16px;
      gap: 12px;
      overflow: hidden;

      .cart-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        border-bottom: 1px solid #e8e8e8;
        font-weight: 600;
        font-size: 16px;
      }

      .cart-list {
        flex: 1;
        overflow-y: auto;
        padding: 10px;
        min-height: 0;

        .empty-cart {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 180px;
          color: #8c8c8c;

          p {
            margin-top: 14px;
          }
        }

        .cart-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          background: #fafafa;
          border-radius: 6px;
          margin-bottom: 10px;
        }

        .item-info {
          flex: 1;

          .item-name {
            font-size: 15px;
            font-weight: 600;
            margin-bottom: 4px;
            line-height: 1.4;
          }

          .item-spec {
            font-size: 13px;
            color: #666;
            margin-bottom: 6px;
            line-height: 1.3;
          }

          .item-price {
            font-size: 18px;
            color: #f5222d;
            font-weight: 700;
          }
        }

        .item-controls {
          display: flex;
          gap: 10px;

          .ant-btn-group {
            display: flex;

            .ant-btn {
              height: 36px;
              min-width: 36px;
              font-size: 15px;
              font-weight: 600;
            }

            .ant-input-number {
              height: 36px;

              /deep/ .ant-input-number-input {
                height: 34px;
                text-align: center;
                font-size: 15px;
                font-weight: 600;
              }

              /deep/ .ant-input-number-handler-wrap {
                display: none;
              }
            }
          }

          .ant-btn {
            height: 36px;
            min-width: 36px;
            font-size: 15px;
            font-weight: 600;
          }
        }
      }

      .cart-summary {
        padding: 14px;
        border-top: 1px solid #e8e8e8;
        background: #fafafa;

        .summary-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 13px;

          &.total {
            font-size: 17px;
            font-weight: 700;
            color: #f5222d;
            margin-top: 14px;
            padding-top: 14px;
            border-top: 1px solid #e8e8e8;
          }

          .total-price {
            color: #f5222d;
          }
        }
      }

      .checkout-actions {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: auto;

        .ant-btn {
          height: 52px;
          font-size: 17px;
          font-weight: 600;
        }
      }
    }

    .member-select-wrapper {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .action-label {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 15px;
        font-weight: 600;
        color: #333;

        .anticon {
          font-size: 20px;
          color: #1890ff;
        }
      }

      .ant-select {
        .ant-select-selection {
          height: 52px;
        }

        .ant-select-selection__rendered {
          line-height: 50px;
        }
      }
    }

    .member-search-btn {
      .ant-btn {
        height: 52px;
        font-size: 17px;
        font-weight: 600;
      }
    }

    .current-member {
      background: #f0f9ff;
      border: 1px solid #bae7ff;
      border-radius: 8px;
      padding: 14px;

      .member-label {
        font-size: 12px;
        color: #8c8c8c;
        margin-bottom: 10px;
      }

      .member-info {
        .member-name {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin-bottom: 8px;
        }

        .member-level {
          margin-bottom: 8px;
        }

        .member-balance {
          font-size: 14px;
          color: #52c41a;
          font-weight: 500;
        }

        // 混合支付样式
        .balance-mix-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 8px;

          .balance-available {
            font-size: 13px;
            color: #52c41a;
            font-weight: 600;
          }
        }

        .balance-mix-body {
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px dashed #d9d9d9;

          .balance-mix-row {
            display: flex;
            align-items: center;
            margin-bottom: 8px;

            .balance-mix-label {
              font-size: 13px;
              color: #595959;
              margin-right: 8px;
            }
          }

          .balance-mix-tip {
            font-size: 13px;
            color: #595959;
          }

          .balance-mix-warn {
            font-size: 12px;
            color: #fa8c16;
            margin-top: 4px;
          }
        }
      }
    }

    // 交班汇总卡片
    .shift-summary {
      margin-bottom: 16px;

      /deep/ .ant-statistic-title {
        font-size: 13px;
        color: #8c8c8c;
      }

      /deep/ .ant-statistic-content {
        font-size: 22px;
        font-weight: 600;
      }
    }
  }
}

// 收银结算弹窗样式
.checkout-modal-container {
  display: flex;
  gap: 16px;
  min-height: 400px;

  .checkout-modal-left {
    flex: 1;
  }

  .checkout-modal-right {
    width: 400px;
    display: flex;
    flex-direction: column;
  }

  .info-table {
    width: 100%;

    tr {
      height: 40px;

      &.total-row {
        border-top: 2px solid #ddd;
        margin-top: 8px;
        padding-top: 8px;
      }
    }

    .label {
      width: 100px;
      color: #666;
      font-size: 14px;
    }

    .value {
      color: #333;
      font-size: 14px;
      font-weight: 500;

      &.discount {
        color: #f5222d;
      }

      &.total {
        color: #f5222d;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  .goods-list {
    .goods-item {
      display: flex;
      gap: 12px;
      padding: 12px;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      .goods-image {
        width: 60px;
        height: 60px;
        object-fit: cover;
        border-radius: 4px;
      }

      .goods-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .goods-name {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .goods-spec {
          font-size: 12px;
          color: #999;
          margin-bottom: 4px;
        }

        .goods-price {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .price {
            color: #f5222d;
            font-size: 16px;
            font-weight: 500;
          }

          .count {
            color: #666;
            font-size: 14px;
          }
        }
      }
    }
  }

  .payment-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .payment-option {
    padding: 10px 12px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;

    &:hover {
      border-color: #1890ff;
      background-color: #f0f8ff;
    }

    &.selected {
      border-color: #1890ff;
      background-color: #e6f7ff;
    }

    .payment-radio {
      width: 100%;
      display: flex;
      align-items: center;

      ::v-deep .ant-radio {
        margin-right: 6px;
      }

      .payment-label {
        font-size: 14px;
      }
    }
  }

  .bottom-actions {
    margin-top: 16px;
  }
}

// 全屏模式样式
.cashier-container.cashier-fullscreen-mode {
  height: 100vh !important;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 998;

  .cashier-content {
    height: 100vh;

    .content-section {
      padding: 0;

      &.cashier-section {
        padding: 0;
      }
    }

    .cashier-section {
      padding: 0;
    }
  }

  .cashier-sidebar {
    height: 100vh;
  }
}

</style>

<style lang="less">
// 收银弹窗样式 - 非scoped
.checkout-modal-wrapper {
  ::v-deep .ant-modal-wrap {
    z-index: 1000000 !important;
  }

  ::v-deep .ant-modal {
    z-index: 1000000 !important;
  }

  ::v-deep .ant-modal-mask {
    z-index: 999999 !important;
  }
}

// 积分抵扣样式
.score-deduction-section {
  .score-toggle-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .score-info {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: #666;

      .score-text {
        .score-value {
          color: #faad14;
          font-weight: 600;
          font-size: 14px;
        }
      }

      .score-rate {
        color: #999;
        font-size: 12px;
      }
    }
  }

  .score-detail-row {
    background: #f9f9f9;
    border-radius: 6px;
    padding: 12px;
    margin-top: 12px;

    .score-detail-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 0;

      &:not(:last-child) {
        border-bottom: 1px dashed #e8e8e8;
      }

      .detail-label {
        font-size: 13px;
        color: #666;
      }

      .detail-value {
        font-size: 15px;
        font-weight: 600;
        color: #333;

        &.highlight {
          color: #f5222d;
        }
      }

      .detail-score {
        font-size: 12px;
        color: #999;
        margin-left: 8px;
      }
    }
  }

  .score-remaining-row {
    margin-top: 12px;
    padding: 10px;
    background: #fff7e6;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;

    .remaining-value {
      color: #faad14;
      font-weight: 600;
      font-size: 14px;
    }
  }
}

// 优惠券样式
.selected-coupon-banner {
  display: flex;
  align-items: center;
  padding: 12px;
  background: linear-gradient(135deg, #fff1f0, #ffccc7);
  border-radius: 8px;
  border: 1px solid #ffa39e;

  .coupon-value {
    font-size: 20px;
    font-weight: 700;
    color: #f5222d;
    margin-left: 12px;
  }
}

.coupon-list {
  max-height: 240px;
  overflow-y: auto;

  .coupon-select-hint {
    font-size: 13px;
    color: #666;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #e8e8e8;
  }

  .coupon-item {
    display: flex;
    align-items: center;
    padding: 12px;
    margin-bottom: 8px;
    background: #fff;
    border: 2px solid #e8e8e8;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;

    &:hover {
      border-color: #ff4d4f;
      box-shadow: 0 2px 8px rgba(255, 77, 79, 0.15);
    }

    &.coupon-disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover {
        border-color: #e8e8e8;
        box-shadow: none;
      }
    }

    .coupon-left {
      flex: 0 0 80px;
      text-align: center;
      border-right: 1px dashed #e8e8e8;
      padding-right: 12px;
      margin-right: 12px;

      .coupon-amount {
        .coupon-symbol {
          font-size: 14px;
          color: #f5222d;
          font-weight: 600;
        }
        .coupon-money {
          font-size: 22px;
          color: #f5222d;
          font-weight: 700;
        }
      }

      .coupon-condition {
        font-size: 11px;
        color: #999;
        margin-top: 4px;
      }

      .coupon-no-limit {
        color: #52c41a;
        font-weight: 600;
      }
    }

    .coupon-right {
      flex: 1;
      min-width: 0;

      .coupon-name {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .coupon-expire {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
      }

      .coupon-unavailable-msg {
        font-size: 11px;
        color: #ff4d4f;
        margin-top: 2px;
      }
    }

    .coupon-check {
      flex: 0 0 auto;
      margin-left: 8px;
    }
  }
}

.coupon-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 12px;
}

// 全局支付蒙层样式
#global-pay-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;

  .global-pay-content {
    background: #fff;
    border-radius: 12px;
    padding: 48px 64px;
    text-align: center;
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2);

    .global-pay-text {
      margin-top: 20px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }

    .global-pay-hint {
      margin-top: 8px;
      font-size: 14px;
      color: #999;
    }
  }
}
</style>


